import React, { useContext } from 'react';
import { Card, CardBody, CardTitle, CardSubtitle } from 'reactstrap';

import { NavLink } from 'react-router-dom';
import GlobalContext from '../../../../../Context/GlobalContext';
import styles from './UserCard.module.css';
import Rating from '@mui/material/Rating';

function UserCard(props) {
  const { setSelectedIntervenantId } = useContext(GlobalContext);

  // On utilise props.user pour définir si l'utilisateur est en ligne
  const isUserOnline = props.user.availability_user === 1;

  const handleEnSavoirPlusClick = () => {
    setSelectedIntervenantId(props.user.id_user);
  };

  return (
    <Card className={styles['user-card']} style={{ position: 'relative' }}>
      
      {/* Badge de disponibilité stylisé */}
      <div
        style={{
          position: "absolute",
          top: "10px",
          left: "10px",
          zIndex: 2,
          padding: "5px 12px",
          borderRadius: "30px",
          fontSize: "12px",
          fontWeight: "600",
          display: "flex",
          alignItems: "center",
          gap: "6px",
          backgroundColor: isUserOnline ? "#53B1A6" : "#f3a109",
          color: "#FFFFFF",
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
        }}
      >
        {/* Point indicateur blanc/rouge */}
        <span
          style={{
            width: "12px",
            height: "12px",
            borderRadius: "50%",
            backgroundColor: "#FFFFFF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span
            className={isUserOnline ? "clignote" : ""} // "item" remplacé par "isUserOnline"
            style={{
              width: "7px",
              height: "7px",
              borderRadius: "50%",
              backgroundColor: isUserOnline  ? "#06f762"
                          : "#e9a410",
            }}
          ></span>
        </span>
        {isUserOnline ? "En ligne" : "Sur RDV"}
      </div>

      <img 
        alt="User" 
        src={`${process.env.REACT_APP_APIURL}/storage/workshop/${props.user.photo_user}`} 
        className={styles['user-photo']} 
      />

      <CardBody className={styles['cardBody']}>
        <div className={styles['rating-section']}>
          <h6 className={styles['satisfaction-label']}>
            Satisfaction clients
          </h6>
          <Rating
            readOnly
            value={props.user.total_reviews_user / 20}
            sx={{
              color: '#4AAE9B',
            }}
          />
        </div>
        
        <CardTitle tag="h6" className={styles['user-name']}>
          <b>{props.user.nom_user} {props.user.prenom_user}</b>
        </CardTitle>
        
        <CardSubtitle className={styles['user-speciality']}>
          {props.user.main_speciality_user}
        </CardSubtitle>

        <div className={styles['en-savoir-plus']}>
          <NavLink
            to={`/intervenants/${props.user.nom_user}-${props.user.prenom_user}`}
            className="btn btn-sm btn_savoir"
            onClick={handleEnSavoirPlusClick}
          >
            En savoir +
          </NavLink>
        </div>
      </CardBody>
    </Card>
  );
}

export default UserCard;